<script lang="ts">
/**
 * Section nav item for menus.
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2025-04-04 (2.0.0) (jhoward)
 *    - Refactor list item from <menu-section-list> to <menu-section-list-item>.
 */

import {defineComponent, PropType} from 'vue'
import {MenuItem, MenuItemWithNormalizedSchedules, MenuSection} from "./defs";
import {computedIsScheduled, isNormalizedScheduleActive} from "../../helpers/menu-sections";

export default defineComponent({
  name: "menu-section-list-item",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    isHighlighted: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isScheduled: computedIsScheduled,
    sectionNavTitle(): string {
      if (this.section.ms_nav_title.length) {
        return this.section.ms_nav_title;
      }
      return this.section.ms_title;
    },
    isEmpty(): boolean {
      let items: MenuItemWithNormalizedSchedules[] = [];
      for (let topGroupKey in this.section.grouped_items) {
        for (let bottomGroupKey in this.section.grouped_items[topGroupKey]) {
          items = items.concat(this.section.grouped_items[topGroupKey][bottomGroupKey]);
        }
      }
      for (let i = 0, l = items.length; i < l; i++) {
        if (!items[i].normalizedSchedules?.length) {
          return false;
        }
        for (let ii = 0, ll = items[i].normalizedSchedules.length; ii < ll; ii++) {
          if (isNormalizedScheduleActive(items[i].normalizedSchedules[ii], this.$store.state.currentDateTimeUtc, this.$store.state.currentDayOfWeek, this.$store.state.currentTimeOfDay)) {
            return false;
          }
        }
      }

      return true;
    },
  },
})
</script>

<template>
  <li class="menu--section_nav_item" :class="{'menu--section_nav_item-current': isHighlighted}">
    <a v-if="section.ms_show_in_nav" v-show="isScheduled && !isEmpty"
       :id="'menu_nav--btn_' + section.ms_id" :ref="'menu_nav--btn_' + section.ms_id"
       class="btn" :class="{'btn-highlight': isHighlighted}"
       :href="'#' + section.ms_id + '-MS'">
      {{ sectionNavTitle }}
    </a>
  </li>
</template>

<style scoped>
a {
  display: block;
  font-size: 0.8rem;
  line-height: 1rem;
}
</style>